import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as React from "react";

import { Paper, Typography } from "mpulse-design-system";
import { styled, Box } from "@mui/material";

import ivrManagerLogo from "./../../images/IVR_Manager.svg";

import { useVersionInfo } from "../../hooks/useVersionInfo";
import LogoutButton from "../LogoutButton/LogoutButton";
import VersionInfo from "../VersionInfo/VersionInfo";

const Header = () => {
  const { client } = useSelector((state) => state);
  const { isVoiceTalent } = useSelector(({ user }) => user.user);
  const { showVersionInfo, setShowVersionInfo, handleVersionInfo } =
    useVersionInfo();

  return client.id || isVoiceTalent ? (
    <StyledPaper square variant="elevation">
      <MPulseLogo
        src={ivrManagerLogo}
        alt="mPulse Logo"
        onClick={handleVersionInfo}
      />
      <Box sx={{ flex: "0 0 108px" }}>
        <Typography variant="body1" color="primary" align="right">
          <StyledLink to="/dashboard">
            <strong>Dashboard</strong>
          </StyledLink>
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: "1",
          justifyContent: "flex-end",
          display: "flex",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" color="textPrimary" align="right">
            {/* TODO: Get role from user API */}
            <strong>
              {isVoiceTalent ? "Voice Talent" : "Account Manager"}
            </strong>
          </Typography>
          <Typography variant="body1" color="textPrimary" align="right">
            {client.name}
          </Typography>
        </Box>
        <LogoutButton sx={{ paddingLeft: (theme) => theme.spacing(2) }} />
      </Box>
      <VersionInfo {...{ showVersionInfo, setShowVersionInfo }} />
    </StyledPaper>
  ) : null;
};

const StyledPaper = styled(Paper)(({ theme }) => ({
    "&.MuiPaper-root": {
      height: theme.spacing(8),
      padding: `0 ${theme.spacing(3)}`,
      display: "flex",
      alignItems: "center",
    },
  })),
  MPulseLogo = styled("img")(() => ({
    height: "29px",
  })),
  StyledLink = styled(Link)(({ theme }) => ({
    position: "relative",
    padding: `${theme.spacing(1)}`,
    color: "inherit",
    textDecoration: "none",
  }));

export default Header;
